export const OTHER_REASON_CHAR_LIMIT = 500;
